import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import IncomingAlert from '../components/IncomingAlert';
import MeetingAlert from './../components/meetingAlert';
import Call from '../components/call';
import { terminateCall, setCallEndedFlag, postSurveyResponse, sendCallToVoiceMail, startCall } from './../actions/init';
import { getTimeData, hideMeetingNotification } from './../actions/mail/mailScheduler';
import { startTutorial, stopTutorial, addStepsToTutorial, updateStepNumber, setEndTutorialPopup } from './../actions/tutorial';
import { endMeeting, decreaseMeetingTimeLeft } from './../actions/meeting';
import { endCall } from './../actions/call';

class CallContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isCallActive: false,
            currentCallId: -1,
            callType: null
        };
    }

    componentDidMount = () => {
        this.setCurrentCallOrMeeting(this.props);
    }
    //TODO: call accepted from voice mail while meeting countdown is going on

    //check timer for meeting notification

    componentWillReceiveProps = (nextProps) => {
        this.setCurrentCallOrMeeting(nextProps);
    }

    setCurrentCallOrMeeting = (nextProps) => {
        let tempCallDetails = null, tempMail = null;

        //If call is already in progress, dont calculate timings for next call/meeting
        if (this.state.currentCallId !== -1) {
            tempMail = nextProps.mails.find(mail => mail.id === this.state.currentCallId)
            //If call is sent to voice mail, reset currentCallId
            if (!this.isCallStarted(tempMail.actionThread) && this.isVoiceMailPresent(tempMail.actionThread)) {
                this.setState({
                    currentCallId: -1,
                    callType: null
                })
            } else if (this.isCallStarted(tempMail.actionThread)) { //in case user accepts a call -> in order to cut short time to start the call
                this.setState({
                    isCallActive: true
                })
            }
        }

        //If call is 'in progress and refreshed' or completed, find next call/meeting
        if (this.state.currentCallId === -1 || this.isCallTerminated(tempMail.actionThread)) {
            this.resetState()
            //Check if any call/meeting is in progress
            tempCallDetails = nextProps.callSequence.find(call => {
                tempMail = nextProps.mails.find(mail => mail.id === call.id)
                if (this.isCallStarted(tempMail.actionThread) && !this.isCallTerminated(tempMail.actionThread))
                    return true
                return false
            })

            if (tempCallDetails) {
                //If call/meeting is in progress
                this.setState({
                    currentCallId: tempCallDetails.id,
                    callType: tempCallDetails.type,
                    isCallActive: true
                })
            } else if (nextProps.callSequence.length > 0) {            //If there is any call in queue
                tempCallDetails = nextProps.callSequence.find(call => {
                    tempMail = nextProps.mails.find(mail => mail.id === call.id)
                    if (!this.isCallStarted(tempMail.actionThread) && !this.isCallTerminated(tempMail.actionThread) && !this.isVoiceMailPresent(tempMail.actionThread))
                        return true
                    return false
                })

                if (tempCallDetails) {                         //If call/meeting is in progress
                    this.setState({
                        currentCallId: tempCallDetails.id,
                        callType: tempCallDetails.type,
                        isCallActive: false
                    })
                }
            }
        }
    }

    resetState = () => {
        this.setState({
            isCallActive: false,
            currentCallId: -1,
            callType: null
        })
    }

    isShownAction = (actionThread) => {
        return actionThread.find((action) => action.type === 'isShown')
    };

    isCallStarted = (actionThread) => {
        return actionThread.some((action) => action.type === 'call_started')
    }

    isCallTerminated = (actionThread) => {
        return actionThread.some((action) => action.type === 'call_terminated')
    }

    isVoiceMailPresent = (actionThread) => {
        return actionThread.some((action) => action.type === 'next_mail')
    }

    findCall = (currentCallId) => {
        let { mails } = this.props;
        return mails.find(call => call.id === currentCallId)
    }

    findMeeting = () => {
        let { meetings } = this.props;
        return meetings.find(meeting => meeting.actionThread && this.isShownAction(meeting.actionThread))
    }

    showCall = () => {
        this.setState({ isCallActive: true })
    }

    closeCallContainer = () => {
        this.resetState()
    }

    displayCall = () => {
        const { uiState, stopCallNotification, actors, tutorial } = this.props;
        let { isCallActive, currentCallId } = this.state;
        return <Fragment>
            {
                uiState.gameState.isIncomingCall && !isCallActive ?
                    <IncomingAlert
                        type="call"
                        callDetail={this.findCall(currentCallId)}
                        actors={actors}
                        stopCallNotification={stopCallNotification}
                        startCall={startCall}
                        currentCallId={currentCallId}
                        showCall={this.showCall}
                        sendCallToVoiceMail={sendCallToVoiceMail}
                        getTimeData={getTimeData}
                        //For tutorial
                        tutorial={tutorial}
                        startTutorial={startTutorial}
                        stopTutorial={stopTutorial}
                        addStepsToTutorial={addStepsToTutorial}
                        updateStepNumber={updateStepNumber}
                    />
                    : null
            }
            {
                isCallActive ?
                    <Call
                        callDetail={this.findCall(currentCallId)}
                        closeCallContainer={this.closeCallContainer}
                        endCall={endCall}
                        endMeeting={endMeeting}
                        terminateCall={terminateCall}
                        setCallEndedFlag={setCallEndedFlag}
                        postSurveyResponse={postSurveyResponse}
                        getTimeData={getTimeData}
                        actors={actors}
                        //For tutorial
                        tutorial={tutorial}
                        startTutorial={startTutorial}
                        stopTutorial={stopTutorial}
                        addStepsToTutorial={addStepsToTutorial}
                        updateStepNumber={updateStepNumber}
                        setEndTutorialPopup={setEndTutorialPopup}
                        //Self Actor id
                        selfActor={uiState.selfActor}
                    />
                    : null
            }
        </Fragment>
    }

    displayMeeting = () => {
        const { uiState, stopMeetingNotification, actors, tutorial } = this.props;
        let { isCallActive, currentCallId } = this.state;
        return <Fragment>
            {
                uiState.gameState.showMeetingNotification ?
                    <MeetingAlert
                        timeLeft={uiState.gameState.meetingTimeLeft}
                        hideMeetingNotification={hideMeetingNotification}
                    />
                    :
                    null
            }
            {
                uiState.gameState.isIncomingMeeting && !isCallActive ?
                    <IncomingAlert
                        type="meeting"
                        stopCallNotification={stopMeetingNotification}
                        startCall={startCall}
                        currentCallId={currentCallId}
                        showCall={this.showCall}
                        decreaseMeetingTimeLeft={decreaseMeetingTimeLeft}
                        countdown={uiState.gameState.countdown}
                        //For tutorial
                        tutorial={tutorial}
                    />
                    : null
            }
            {
                isCallActive ?
                    <Call
                        callDetail={this.findCall(currentCallId)}
                        closeCallContainer={this.closeCallContainer}
                        endCall={endCall}
                        endMeeting={endMeeting}
                        terminateCall={terminateCall}
                        setCallEndedFlag={setCallEndedFlag}
                        postSurveyResponse={postSurveyResponse}
                        getTimeData={getTimeData}
                        actors={actors}
                        //For tutorial
                        tutorial={tutorial}
                        //Self Actor id
                        selfActor={uiState.selfActor}
                    />
                    : null
            }
        </Fragment>
    }

    render() {
        let { callType } = this.state;
        return (
            <Fragment>
                {
                    callType === "call" ?
                        this.displayCall()
                        :
                        callType === "meeting" && this.displayMeeting()
                }
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        uiState: state.uiState,
        actors: state.actors,
        callSequence: state.callSequence,
        mails: state.mails,
        tutorial: state.tutorial
    };
}

export default connect(mapStateToProps)(CallContainer);


// WEBPACK FOOTER //
// /src/containers/CallContainer.js